"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _PositionInput = _interopRequireDefault(require("./PositionInput"));

var _utils = require("../../../../../../../utils");

var _getAssetMetaDataField = _interopRequireDefault(require("../../../../../utils/getAssetMetaDataField"));

require("../styles/_list-clip.scss");

var _AssetTitle = _interopRequireDefault(require("../../../../../../../../../common/components/AssetTitle/containers/AssetTitle"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function withNoEventPropagation(fn) {
  return function (e) {
    e.preventDefault();
    e.stopPropagation();
    fn();
  };
}

var ListClip = /*#__PURE__*/function (_Component) {
  _inherits(ListClip, _Component);

  var _super = _createSuper(ListClip);

  function ListClip(_ref) {
    var _this;

    var onRemoveClip = _ref.onRemoveClip;

    _classCallCheck(this, ListClip);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "setClipRef", function (el) {
      if (!el) {
        return;
      }

      _this._clipRef = el;
    });

    _defineProperty(_assertThisInitialized(_this), "onOrderClick", function (newIndex) {
      var onChangeIndex = _this.props.onChangeIndex;
      return withNoEventPropagation(function () {
        onChangeIndex(newIndex);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addTransitionToClip", function () {
      if (!_this._clipRef || _this._clipRef.style.position !== 'absolute') {
        return;
      }

      _this._clipRef.style.transition = 'all 0.3s ease-in-out';
    });

    _this.onRemoveClip = withNoEventPropagation(onRemoveClip);
    return _this;
  }

  _createClass(ListClip, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(prevProps) {
      return !(0, _lodash.default)(prevProps, this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOver = this.props.isOver;

      if (!prevProps.isOver && isOver && this._clipRef) {
        this._clipRef.style.position = 'absolute'; // Allows the DOM to repaint with absolute positioning without triggering a transition immediately

        setTimeout(this.addTransitionToClip, 0);
      }

      if (prevProps.isOver && !isOver && this._clipRef) {
        this._clipRef.style.position = '';
        this._clipRef.style.transition = '';
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isImage = _this$props.isImage,
          selected = _this$props.selected,
          onSelect = _this$props.onSelect,
          index = _this$props.index,
          clipsLength = _this$props.clipsLength,
          onChangeIndex = _this$props.onChangeIndex,
          isOver = _this$props.isOver,
          position = _this$props.position,
          onDragEnter = _this$props.onDragEnter,
          asset = _this$props.asset,
          canUpdateVideo = _this$props.canUpdateVideo,
          commentsQuantity = _this$props.commentsQuantity,
          assetId = _this$props.assetId;
      return (/*#__PURE__*/_react.default.createElement("div", {
          onClick: onSelect,
          className: (0, _classnames.default)('list-clip', {
            'list-clip--selected': selected,
            'list-clip--disabled': !canUpdateVideo
          }),
          style: {
            transform: isOver ? "translateY(calc(".concat(position * 100, "% + ").concat(20 * position, "px))") : void 0
          },
          ref: this.setClipRef,
          role: "button",
          tabIndex: 0,
          onDragEnter: onDragEnter,
          onKeyPress: (0, _onEnterPressed.default)({
            onClick: onSelect,
            allowPropagation: true
          })
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "list-clip__left-content"
        }, /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
          assetId: assetId,
          height: "75px",
          width: "75px",
          darkMode: true
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "list-clip__left-content__description"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "list-clip__left-content__description__text"
        }, asset && /*#__PURE__*/_react.default.createElement(_AssetTitle.default, {
          assetId: assetId
        }), !isImage ? /*#__PURE__*/_react.default.createElement("p", null, (0, _utils.getTimestamp)((0, _getAssetMetaDataField.default)('duration', asset))) : null), canUpdateVideo ? /*#__PURE__*/_react.default.createElement("div", {
          className: "list-clip__left-content__description__actions"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "trash",
          size: 15,
          color: "nevada",
          onClick: this.onRemoveClip,
          hoverColor: "redApple"
        })) : null)), /*#__PURE__*/_react.default.createElement("div", {
          className: "list-clip__right-content"
        }, /*#__PURE__*/_react.default.createElement(_PositionInput.default, {
          value: index + 1,
          onChange: onChangeIndex,
          clipsLength: clipsLength,
          canUpdateVideo: canUpdateVideo
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "list-clip__right-content__comments"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "comments",
          color: "regent",
          size: 15
        }), /*#__PURE__*/_react.default.createElement("p", null, commentsQuantity))), selected ? /*#__PURE__*/_react.default.createElement("div", {
          className: "list-clip__order"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "arrowup",
          size: 15,
          color: index === 0 ? 'jumbo' : 'white',
          onClick: index > 0 ? this.onOrderClick(index - 1) : void 0
        }), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "arrowdown",
          size: 15,
          color: index === clipsLength - 1 ? 'jumbo' : 'white',
          onClick: index < clipsLength - 1 ? this.onOrderClick(index + 1) : void 0
        })) : null)
      );
    }
  }]);

  return ListClip;
}(_react.Component);

exports.default = ListClip;